import Heatmap from "heatmap.js";
import _ from "lodash";
import React from "react";
import ReactDOM from "react-dom";

class ReactHeatmap extends React.Component {
    componentDidMount() {
        const configObject = Object.assign(
            {
                container: ReactDOM.findDOMNode(this),
            },
            this.props.configObject
        );

        this.heatmap = Heatmap.create(configObject);

        this.setData(this.props.min, this.props.max, this.props.data);
    }

    componentWillReceiveProps(nextProps) {
        if (!this.shouldComponentUpdate(nextProps)) {
            return;
        }

        this.setData(nextProps.min, nextProps.max, nextProps.data);
    }

    setData = (min, max, data) => {
        this.heatmap.setData({ min, max, data });
    };

    shouldComponentUpdate(nextProps) {
        const a = (nextProps && nextProps.data) || [];
        const b = (this.props && this.props.data) || [];
        return !_.isEqual(a, b);
    }

    render() {
        return <div style={{ width: "100%", height: "100%" }} />;
    }
}

ReactHeatmap.propTypes = {
    max: React.PropTypes.number,
    min: React.PropTypes.number,
    data: React.PropTypes.arrayOf(React.PropTypes.object),
    configObject: React.PropTypes.object,
};

ReactHeatmap.defaultProps = {
    max: 5,
    min: 0,
    data: [],
    configObject: {},
};

export default ReactHeatmap;



// WEBPACK FOOTER //
// ./src/components/ReactHeatmap.js